import { render, staticRenderFns } from "./AlternativeContract.vue?vue&type=template&id=4901d489&"
import script from "./AlternativeContract.vue?vue&type=script&lang=js&"
export * from "./AlternativeContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports